import { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BsArrowRightShort } from 'react-icons/bs';
import BaseText from 'components/common/BaseText';
import { useSelector } from 'react-redux';

const StepLayout = ({ children, title, withoutStep = false }) => {
  const { step } = useSelector((state) => state.global);

  return (
    <StepLayoutWrapper>
      {!withoutStep && (
        <StepLayoutNumber>
          <span>{step}</span>
          <BsArrowRightShort />
        </StepLayoutNumber>
      )}
      <BaseText type='big'>{title}</BaseText>
      {children}
    </StepLayoutWrapper>
  );
};

const StepLayoutWrapper = styled.div`
  position: relative;
  min-width: 300px;
`;

const StepLayoutNumber = styled.div`
  position: absolute;
  left: -36px;
  top: 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 16px;
    line-height: 32px;
    font-family: ${({ theme }) => theme.typography.family};
  }
  > svg {
    width: 20px;
    height: 20px;
  }
`;

StepLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  withoutStep: PropTypes.bool,
};

export default memo(StepLayout);
